import { css } from 'lit-element';

// language=CSS
export const style = css`
    :host {
        overflow: auto;
      
        --sw-dialog-simple-width: 80%;
        --sw-dialog-simple-height: 80%;

        --button-contained-padding: 8px 16px;
        --button-contained-radius: 8px;
        
        --fullscreen-spinner-bg: #ffffff;
        --input-textarea-height: 150px;
        
        transition: all 300ms ease-in;
    }
    
    .banner-container {        
        position: relative;
        overflow: hidden;
        height: 350px;
        width: 100%;
    }

    slot {
        position: relative;
        display: block;
        z-index: 1;
    }

    .banner {
        position: absolute;
        top: 0;
        display: block;
        height: 100%;
        width: 100%;

        background:  var(--app-accent);
        background: -moz-linear-gradient(top,   var(--app-accent) 0%, var(--app-accent-light) 100%);
        background: -webkit-linear-gradient(top,  var(--app-accent) 0%, var(--app-accent-light) 100%);
        background: linear-gradient(to bottom,  var(--app-accent) 0%, var(--app-accent-light) 100%);


        border-bottom-left-radius: 50% 25%;
        border-bottom-right-radius: 50% 25%;
        margin: 0 -40px;
        padding: 0 40px;
        color: #FFFFFF;
    }

    .section {
        width: 1280px;
        padding: 40px;
        z-index: 1;
        background-color: var(--app-white);
    }

    .section.first {
        margin-top: -100px;
    }

    
    .item {
        position: relative;
        min-width: calc(33.3% - 80px);
        max-width: calc(33.3% - 80px);

        padding: 20px;
        margin: 20px;
        box-shadow: 0 1px 24px var(--shadow-color);
        background-color: #FFFFFF;
        transition: all 300ms ease-in;
    }
    
    .item:hover {
        color: #FFFFFF;
        background:  var(--app-accent);
        background: -moz-linear-gradient(right,   var(--app-accent) 0%, var(--app-accent-light) 100%);
        background: -webkit-linear-gradient(right,  var(--app-accent) 0%, var(--app-accent-light) 100%);
        background: linear-gradient(to right,  var(--app-accent) 0%, var(--app-accent-light) 100%);
    }
    
    .item a {
        display: block;
        width: 100%;
        height: 100%;
        text-decoration: none;
        color: var(--app-primary-color);
        font-weight: bold;
    }
    
    .item:hover a {
        color: #FFFFFF;
    }
    
    .payment-summary {
        line-height: 40px;
        background-color: var(--app-lightgrey);
        padding: 15px;
        margin: 40px 0;
        border-top: 2px solid var(--app-primary);
    }
    
    .shadow {
        box-shadow: 0 2px 60px var(--shadow-color);
    }
    
    button-contained {
        border-radius: var(--button-contained-radius);
        box-shadow: 0 2px 60px var(--app-accent-light);
        margin: 20px auto;
    }
    button-contained[disabled] {
        box-shadow: none;
    }
    button-outlined {
        margin: 10px auto;
    }
    
    icon {    
        display: block;
        height: 16px;
        width: 16px;
    }
    
    icon[app-red] path,
    icon[app-red] svg,
    icon[app-red] {
        color: var(--app-red);
        fill: var(--app-red);
    }
    
    .bar-action {
        background-color: var(--app-white, #FFF);
        margin-left: auto;
        padding: 20px 80px;
        border-radius: 0  0 0 80px;
    }

    input-checkbox-list, input-select, input-default {
        min-width: calc(20% - 30px);
    }

    @media only screen and (max-width: 1360px) {
        .section {
            max-width: calc(100% - 80px);
        }
    }
`;